
import React from 'react';
import PropTypes from 'prop-types';

import styles from './PopOverAction.module.scss';

PopOverAction.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
PopOverAction.defaultProps = {
  className: '',
};

export default function PopOverAction(props) {
  const {
    className,
    icon,
    label,
    onClick,
  } = props;

  return (
    <button
      className={ `
        ${styles.PopOverAction}
        ${className}
      ` }
      onClick={ onClick }
      type="button"
    >
      {icon} {label}
    </button>
  );
}
